// extracted by mini-css-extract-plugin
module.exports = {"container":"YandexWidgetReviews_container__R4ljj","containerImageContainer":"YandexWidgetReviews_container-image-container__MQzR6"};